var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "multi-header has-bottom-margin mx-4-mobile" },
        [
          _c("div", { staticClass: "is-flex is-align-self-center" }, [
            _c(
              "nav",
              {
                staticClass: "breadcrumb",
                attrs: { "aria-label": "breadcrumb" },
              },
              [
                _c("h1", { staticClass: "title has-text-centered-touch" }, [
                  _c("ul", [
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.go(-1)
                            },
                          },
                        },
                        [
                          _vm._m(0),
                          _c("span", [_vm._v(_vm._s(_vm.$t("generals.back")))]),
                        ]
                      ),
                    ]),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "dashboard",
                                params: {
                                  lang: _vm.$route.params.lang,
                                  departmentId: _vm.$route.params.departmentId,
                                },
                              },
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "home" } }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("generals.home"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "settings",
                                params: {
                                  lang: _vm.$route.params.lang,
                                  departmentId: _vm.$route.params.departmentId,
                                },
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("component.settings.title")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "configuration_loggers",
                                params: {
                                  lang: _vm.$route.params.lang,
                                  departmentId: _vm.$route.params.departmentId,
                                },
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "component.settings.location.logger_settings"
                                  )
                                )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("li", { staticClass: "is-active" }, [
                      _c("a", { attrs: { href: "", "aria-current": "page" } }, [
                        _vm._v(_vm._s(_vm.source.name)),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
          !_vm.isLoading
            ? _c(
                "b-dropdown",
                {
                  attrs: {
                    position: "is-bottom-left",
                    "append-to-body": "",
                    "aria-role": "list",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function () {
                          return [
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "admin.component.loggers.detail.actions.title"
                                  ),
                                  position: "is-left",
                                  type: "is-dark",
                                },
                              },
                              [
                                _c(
                                  "b-button",
                                  { staticStyle: { "font-size": "1rem" } },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        type: "is-primary",
                                        icon: "ellipsis-v",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3412236272
                  ),
                },
                [
                  _vm.$userCan(_vm.$customerPermissions.SOURCES_MANAGE) &&
                  _vm.$userCan(_vm.$customerPermissions.LOGGERS_READ)
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "custom-dropdown-item",
                          attrs: { "aria-role": "listitem" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteLogger()
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "level is-mobile" }, [
                            _c(
                              "div",
                              { staticClass: "level-left mr-1" },
                              [
                                _c("b-icon", { attrs: { icon: "trash" } }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "component.logger.list.delete_logger"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "level-right pl-1" },
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      type: "is-dark",
                                      label: _vm.$t(
                                        "component.logger.list.delete_logger_note"
                                      ),
                                      position: "is-left",
                                      multilined: "",
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        size: "is-small",
                                        icon: "question-circle",
                                        type: "is-grey",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.$userCan(_vm.$customerPermissions.SOURCES_MANAGE) &&
                  _vm.$userCan(_vm.$customerPermissions.LOGGERS_READ) &&
                  _vm.source.logger
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "custom-dropdown-item",
                          attrs: { "aria-role": "listitem" },
                          on: {
                            click: function ($event) {
                              return _vm.openChangeLogger(true)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "level is-mobile" }, [
                            _c(
                              "div",
                              { staticClass: "level-left mr-1" },
                              [
                                _c("b-icon", { attrs: { icon: "sync-alt" } }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "component.logger.list.reassign_loggers"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "level-right pl-1" },
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      type: "is-dark",
                                      label: _vm.$t(
                                        "component.logger.list.reassign_loggers_note"
                                      ),
                                      position: "is-left",
                                      multilined: "",
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        size: "is-small",
                                        icon: "question-circle",
                                        type: "is-grey",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.$userCan(_vm.$customerPermissions.SOURCES_MANAGE) &&
                  _vm.$userCan(_vm.$customerPermissions.LOGGERS_READ) &&
                  !_vm.source.logger
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "custom-dropdown-item",
                          attrs: { "aria-role": "listitem" },
                          on: {
                            click: function ($event) {
                              return _vm.openChangeLogger(false)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "level is-mobile" }, [
                            _c(
                              "div",
                              { staticClass: "level-left mr-1" },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "level-up-alt" },
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "component.logger.list.assign_loggers"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "level-right pl-1" },
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      type: "is-dark",
                                      label: _vm.$t(
                                        "component.logger.list.assign_loggers_note"
                                      ),
                                      position: "is-left",
                                      multilined: "",
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        size: "is-small",
                                        icon: "question-circle",
                                        type: "is-grey",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.source.logger &&
                  _vm.$userCan(_vm.$customerPermissions.SOURCES_MANAGE)
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "custom-dropdown-item",
                          attrs: { "aria-role": "listitem" },
                          on: {
                            click: function ($event) {
                              return _vm.openDiscardLoggerModal()
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "level is-mobile" }, [
                            _c(
                              "div",
                              { staticClass: "level-left mr-1" },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "level-down-alt" },
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "component.logger.list.discard_logger"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "level-right pl-1" },
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      type: "is-dark",
                                      label: _vm.$t(
                                        "component.logger.list.discard_logger_note"
                                      ),
                                      position: "is-left",
                                      multilined: "",
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        size: "is-small",
                                        icon: "question-circle",
                                        type: "is-grey",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.$userCan(_vm.$customerPermissions.SOURCES_MANAGE_SERVICE)
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "custom-dropdown-item",
                          attrs: {
                            "aria-role": "listitem",
                            disabled: _vm.hasService,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openServiceModal()
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "level is-mobile" }, [
                            _c(
                              "div",
                              { staticClass: "level-left mr-1" },
                              [
                                _c("b-icon", { attrs: { icon: "wrench" } }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "component.logger.service.btn_label"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "level-right pl-1" },
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      type: "is-dark",
                                      label: _vm.$t(
                                        "component.logger.service.btn_tooltip"
                                      ),
                                      position: "is-left",
                                      multilined: "",
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        size: "is-small",
                                        icon: "question-circle",
                                        type: "is-grey",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.hasReadDataFeature
                    ? _c(
                        "b-dropdown-item",
                        {
                          staticClass: "custom-dropdown-item",
                          attrs: {
                            "aria-role": "listitem",
                            disabled: !_vm.canReadData,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openReadDataModal()
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "level is-mobile" }, [
                            _c(
                              "div",
                              { staticClass: "level-left mr-1" },
                              [
                                _c("b-icon", { attrs: { icon: "book-open" } }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "admin.component.loggers.detail.actions.readData"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "level-right pl-1" },
                              [
                                _c(
                                  "b-tooltip",
                                  {
                                    attrs: {
                                      type: "is-dark",
                                      label: _vm.$t(
                                        "admin.component.loggers.detail.actions.readDataNote"
                                      ),
                                      position: "is-left",
                                      multilined: "",
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        size: "is-small",
                                        icon: "question-circle",
                                        type: "is-grey",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.isLoading
        ? _c("b-loading", {
            attrs: {
              "is-full-page": true,
              active: _vm.isLoading,
              "can-cancel": false,
            },
            on: {
              "update:active": function ($event) {
                _vm.isLoading = $event
              },
            },
          })
        : _c("div", { staticClass: "tile is-ancestor is-vertical" }, [
            _c("div", { staticClass: "tile is-parent" }, [
              _c(
                "div",
                { staticClass: "tile is-child box" },
                [
                  _c("LoggerInfo", {
                    ref: "loggerInfoComponent",
                    attrs: {
                      source: _vm.source,
                      sourceGroups: _vm.sourceGroups,
                      quantities: _vm.quantities,
                      eventTypes: _vm.eventTypes,
                      tier: _vm.tier,
                      dateTimeManager: _vm.dateTimeManager,
                    },
                    on: {
                      editingLogger: _vm.editingLogger,
                      reloadSource: _vm.loadData,
                      editService: _vm.openEditServiceModal,
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "tile is-parent" },
              [
                _c("LoggerChanges", {
                  staticClass: "tile is-child box",
                  attrs: {
                    sourceChanges: _vm.sourceChanges,
                    dateTimeManager: _vm.dateTimeManager,
                  },
                  on: { reloadSource: _vm.loadData },
                }),
              ],
              1
            ),
            _vm.source.hasLogger()
              ? _c(
                  "div",
                  { staticClass: "tile is-parent" },
                  [
                    _c("LoggerRssiChart", {
                      staticClass: "tile is-child box",
                      attrs: {
                        dateTimeManager: _vm.dateTimeManager,
                        rssi: _vm.rssiData,
                        source: _vm.source,
                        isLoadingSignal: _vm.isLoadingSignal,
                      },
                      on: { loadSignal: _vm.loadSignal },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isUnsavedChangesModalActive,
            "has-modal-card": "",
            onCancel: _vm.closeUnsavedChangesModal,
          },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedChangesModalActive = $event
            },
            "close-modal": _vm.closeUnsavedChangesModal,
          },
        },
        [
          _c("UnsavedChangesDialog", {
            attrs: { routeToNavigate: _vm.routeToNavigate },
            on: {
              modalClosed: _vm.closeUnsavedChangesModal,
              cancel: _vm.closeUnsavedChangesModal,
              save: _vm.saveUnsavedChanges,
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isServiceModalActive,
            "has-modal-card": "",
            onCancel: _vm.closeServiceModal,
          },
          on: {
            "update:active": function ($event) {
              _vm.isServiceModalActive = $event
            },
            "close-modal": _vm.closeServiceModal,
          },
        },
        [
          _c("SetServiceModal", {
            attrs: { source: _vm.source, dateTimeManager: _vm.dateTimeManager },
            on: {
              modalClosed: _vm.closeServiceModal,
              cancel: _vm.closeServiceModal,
              createService: _vm.createService,
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isDiscardLoggerModal,
            "has-modal-card": "",
            onCancel: _vm.closeDiscardLoggerModal,
          },
          on: {
            "update:active": function ($event) {
              _vm.isDiscardLoggerModal = $event
            },
            "close-modal": _vm.closeDiscardLoggerModal,
          },
        },
        [
          _c("DiscardLoggerModal", {
            attrs: {
              source: _vm.source,
              annotateLogerStateChange: _vm.annotateLogerStateChange === "true",
            },
            on: {
              modalClosed: _vm.closeDiscardLoggerModal,
              reloadSource: _vm.loadData,
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditServiceModalActive,
            "has-modal-card": "",
            onCancel: _vm.closeEditServiceModal,
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditServiceModalActive = $event
            },
            "close-modal": _vm.closeEditServiceModal,
          },
        },
        [
          _c("EditServiceModal", {
            attrs: { source: _vm.source, dateTimeManager: _vm.dateTimeManager },
            on: {
              modalClosed: _vm.closeEditServiceModal,
              cancel: _vm.closeEditServiceModal,
              editService: _vm.editService,
            },
          }),
        ],
        1
      ),
      _vm.$userCan(_vm.$customerPermissions.SOURCES_MANAGE) &&
      _vm.$userCan(_vm.$customerPermissions.LOGGERS_READ)
        ? _c(
            "b-modal",
            {
              attrs: {
                active: _vm.isChangeLoggerModalActive,
                "has-modal-card": "",
                onCancel: _vm.closeChangeLoggerModal,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isChangeLoggerModalActive = $event
                },
                "close-modal": _vm.closeChangeLoggerModal,
              },
            },
            [
              _c("ChangeLoggerModal", {
                attrs: {
                  source: _vm.source,
                  companyLoggers: _vm.availableCompanyLoggers,
                  modalIsReassigning: _vm.modalIsReassigning,
                  annotateLogerStateChange:
                    _vm.annotateLogerStateChange === "true",
                },
                on: {
                  modalClosed: _vm.closeChangeLoggerModal,
                  reloadSource: _vm.loadData,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isReadDataModalActive,
            "has-modal-card": "",
            onCancel: _vm.closeReadDataModal,
            "can-cancel": ["escape", "x"],
          },
          on: {
            "update:active": function ($event) {
              _vm.isReadDataModalActive = $event
            },
            "close-modal": _vm.closeReadDataModal,
          },
        },
        [
          _vm.source && _vm.source.logger
            ? _c("ReadDataFromLoggerModal", {
                attrs: {
                  logger: _vm.source.logger,
                  dateTimeManager: _vm.dateTimeManager,
                  usedByCustomer: true,
                },
                on: {
                  modalClosed: _vm.closeReadDataModal,
                  readData: _vm.readData,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon mr-0" }, [
      _c("i", { staticClass: "fas fa-chevron-left" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }